import React, { useEffect } from "react";
import styles from "./WeddingWallClient.module.css";
import { TextComponent } from "../../../components";
import img from "../../../assets/staticImages/photoimg1.png";
import placeholderImg from "../../../assets/dummy.png";
import dots from "../../../assets/pfdots.png";
import { List } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { EventMiddleware } from "../../../Store/Middlewares/EventMiddleware";
import { DotsIcon } from "../../../components/icons/Icons";
const WeddingWallClient = () => {
  const EventDetails = useSelector((state) => state.EventReducer.EventDetails);
  const WeddingWall = useSelector((state) => state.EventReducer.WeddingWall);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(EventMiddleware.getEventWeddingWall(EventDetails?.id));
  }, []);

  const renderItem = (item, index) => {
    return (
      <div className={styles.listItem}>
        <div className={styles.listuserDetail}>
          <div className={styles.listimages}>
            <img
              src={item?.user_image ? item?.user_image : placeholderImg}
              className={styles.listpfImg}
            />
            <DotsIcon className={styles.listdots} />
            {/* <img src={dots} className={styles.listdots} /> */}
          </div>
          <TextComponent text={item?.name} textClass={styles.dtlname} />
        </div>
        <TextComponent text={item?.note} textClass={styles.listDesc} />
      </div>
    );
  };
  return (
    <div className={styles.mainCont}>
      <div className={styles.dtlusersImg}>
        <div className={styles.dtluserDetail}>
          <div className={styles.images}>
            <img
              src={
                EventDetails?.bride?.image
                  ? EventDetails?.bride?.image
                  : placeholderImg
              }
              className={styles.dtlpfImg}
            />
            <DotsIcon className={styles.dots} />
          </div>
          <TextComponent
            text={EventDetails?.bride?.name}
            textClass={styles.dtlname}
          />
        </div>
        <div className={styles.dtluserDetail}>
          <div className={styles.images}>
            <img
              src={
                EventDetails?.groom?.image
                  ? EventDetails?.groom?.image
                  : placeholderImg
              }
              className={styles.dtlpfImg}
            />
            <DotsIcon className={styles.dots} />
          </div>
          <TextComponent
            text={EventDetails?.groom?.name}
            textClass={styles.dtlname}
          />
          {/* <TextComponent text={"Groom"} textClass={styles.role} /> */}
        </div>
      </div>
      <TextComponent
        text={"Wishes for your best day ever"}
        textClass={styles.desc}
      />
      <TextComponent
        text={`${EventDetails?.groom?.first_name} & ${EventDetails?.bride?.first_name}`}
        textClass={styles.BGname}
      />
      <TextComponent text={"Wedding Ceremony"} textClass={styles.category} />
      <List
        dataSource={WeddingWall}
        renderItem={renderItem}
        className={styles.list}
        grid={{ lg: 3, xxl: 3, xl: 3, xs: 1, md: 2, sm: 1 }}
      />
    </div>
  );
};

export default WeddingWallClient;
